module.exports = __webpack_public_path__ + "fonts/ARIALNB.a124283e.TTF";